import React from "react";
import "./css/AboutPage.css";

interface AboutPageProps {
    version: string;
}

export const AboutPage: React.FC<AboutPageProps> = ({ version }) => {
    return (
        <div className="about-container">
            <p className="about-text">
                Skitterbook is a creative tool designed to transform short video clips
                into expressive, flipbook‑style animations. It focuses on clarity,
                predictability, and emotional resonance, giving users a simple way to
                explore motion, storytelling, and print‑ready frame sequences without
                technical friction.
            </p>
            <p className="about-text">
                The aim of Skitterbook is to make the process of capturing movement
                playful, accessible, and reliable. Whether you're experimenting with
                animation, preparing physical flipbooks, or exploring visual rhythm,
                Skitterbook provides a clean, distraction‑free environment that supports
                creative flow.
            </p>
            <p className="about-version">
                <strong>Version:</strong> {version}
            </p>
        </div>
    );
};

export default AboutPage;
